import script from "./CampaignsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignsSection.vue?vue&type=script&setup=true&lang=js"

import "./CampaignsSection.vue?vue&type=style&index=0&id=fa9b3678&scoped=true&lang=css"

import exportComponent from "/home/berisalam-console-demo/webapps/berisalam-console-demo/releases/1787064449663/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa9b3678"]])

export default __exports__